module.exports = __webpack_public_path__ + "img/transaction.45368d61.png";